// Version utility - gets version from environment variable
// Version is set via REACT_APP_VERSION environment variable during build
// This ensures version is available at build time and runtime
// The version is automatically set from package.json version in build scripts

// Get version from environment variable (set in build scripts)
// Fallback to default if not set
const getVersionFromEnv = () => {
    // Check if version is set via environment variable (set in build scripts)
    if (process.env.REACT_APP_VERSION) {
        return process.env.REACT_APP_VERSION;
    }
    
    // Fallback to default version if not set
    // This should only happen in development if scripts haven't been run
    return '0.0.1.20251202';
};

export const getAppVersion = () => {
    return getVersionFromEnv();
};

export const APP_VERSION = getVersionFromEnv();

